import { setUserData } from "service/mapper";
import { apiGet } from "../baseApi";

export const getList = async ({params={}, config = {}}) => {
  try {
    const response = await apiGet("_user", params, null, config);

    return {
      ...response,
      rowData: (Array.isArray(response.data.users) ? response.data.users : []).map((el) => {
        const userData = setUserData(el);
        if(!!params.district_id && userData.tags.length) {
          userData.tags = userData.tags.filter(el => el.district_id === params.district_id);
        }
        return userData;
      }),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
